import getScenarioStore from '../selectors/getScenarioStore';
import { mutator } from 'satcheljs';
import { setSearchText } from '../actions/internalActions';

export default mutator(setSearchText, actionMessage => {
    getScenarioStore(actionMessage.scenarioId).searchText = actionMessage.searchText;
});
